<template>
  <div class="color-picker">
    <div @click="openColorPicker">
      <slot>
        <v-sheet :color="color" width="88px" height="10px" class="ml-4 color-picker__selector" style="" />
      </slot>
    </div>
    <v-color-picker
      v-show="show"
      v-click-outside-element="closeNativePicker"
      :value="color"
      dot-size="25"
      :hide-inputs="hideInputs"
      swatches-max-height="200"
      elevation="15"
      :mode="mode"
      class="color-picker__native"
      @update:color="updateColor"
    />
  </div>
</template>

<script>
export default {
  name: "ColorPicker",
  props: {
    color: {
      type: String,
      default: "#eeeeee",
    },
    mode: {
      type: String,
      default: 'hexa'
    },
    hideInputs:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      open: false,
      timeout: null,
    };
  },
  watch: {
    show: {
      handler(newStatus) {
        if (newStatus) {
          this.timeout = setTimeout(() => {
            this.open = newStatus;
          }, 500);
        } else {
          clearTimeout(this.timeout);
          this.open = false;
        }
      },
    },
  },
  methods: {
    closeNativePicker() {
      if (!this.open) return;
      this.show = false;
    },
    openColorPicker() {
      this.show = true;
    },
    updateColor(colorObj) {
      this.$emit("pickedColor", colorObj["hex"]);
    },
  },
};
</script>

<style lang="scss" scoped>
.color-picker {
  position: relative;

  &__native {
    position: absolute;
    right: -300px;
    bottom: 0;
    z-index: 1100;
    width: 300px;
    height: 260px;
  }

  &__selector {
    position: absolute;
    right: 22px;
    bottom: 26px;
    z-index: 1000;
    width: 88px;
    height: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
</style>
